import { render, staticRenderFns } from "./LocalityCustomField.vue?vue&type=template&id=60e3a37a"
import script from "./LocalityCustomField.vue?vue&type=script&lang=js"
export * from "./LocalityCustomField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports